import Vue from 'vue';
import axios from 'axios'

const state = {
}

const mutations = {
}

const actions = {
    getFlags({ dispatch}, params){
        if(params.type == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_TS}/flags?package_id=${params.package_id}`);
        }
        return axios.get(`${process.env.VUE_APP_API_TS}/flags?mr_id=${params.mr_id}`);
    },
    getTSInfo({ dispatch}, ts_id){
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/document?ts_id=${ts_id}`);
    },
    getVendorList({ dispatch}, params){
        if(params.type == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_TS}/mr/vendors_list?package_id=${params.package_id}`);
        }
        return axios.get(`${process.env.VUE_APP_API_TS}/mr/vendors_list?mr_id=${params.mr_id}`);
    },
    updateTechnicalSummaryContent({ dispatch}, params) {
        return axios.post(`${process.env.VUE_APP_API_TS}/ts/save/html`, params);
    },
    fetchTechnicalSummaryContent({ dispatch}, params) {
        return axios.post(`${process.env.VUE_APP_API_TS}/ts/view/html`, params);
    },
    initiateTechnicalSummary({ dispatch}, params){
        return axios.post(`${process.env.VUE_APP_API_TS}/ts`, params);
    },
    getTechnicalSummaryInfo({ dispatch}, ts_id){
        return axios.get(`${process.env.VUE_APP_API_TS}/ts?ts_id=${ts_id}`);
    },
    getTimeline({ dispatch}, ts_id) {
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/timeline?ts_id=${ts_id}`);
    },
    reloadDefaultTSContent({ dispatch}, params) {
        return axios.put(`${process.env.VUE_APP_API_TS}/ts/html/reset`, params);
    },
    uploadDocs({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_TS}/ts/document`, params);
    },
    getDocList({commit}, ts_id) {
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/document?ts_id=${ts_id}`);
    },
    generatePreview({commit}, params){
        return axios.post(`${process.env.VUE_APP_API_TS}/ts/printpreview`, params);
    },
    download({commit}, params) {
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/download?ts_id=${params.ts_id}`);
    },
    downloadProgress({commit}, params) {
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/download/progress?ts_id=${params.ts_id}&file_process_id=${params.file_process_id}`);
    },
    getTSRevInfo({ dispatch}, params){
        if(params.type == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_TS}/ts/revisions?package_id=${params.package_id}`);
        }
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/revisions?mr_id=${params.mr_id}`);
    },
    previewFile({ dispatch}, params){
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/document/view?ts_id=${params.ts_id}&document_name=${params.docName}&file_node_id=${params.node_id}`);
    },
    getProjectUsers({state}, params) {
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/project/user?project=${params.projectId}&ts_id=${params.ts_id}&page=approver`);
    },
    deleteDocument({ dispatch}, params){
        return axios.delete(`${process.env.VUE_APP_API_TS}/ts/document`, {data:params});
    },
    inviteForReview({ dispatch}, params){
        return axios.post(`${process.env.VUE_APP_API_TS}/ts/user/review`, params);
    },
    getInvitedUsers({ dispatch}, ts_id) {
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/user/review?ts_id=${ts_id}`);
    },
    getCollabThreads({commit}, payload) {
        //  let links = ''
        //     if(payload?.dis) {
        //         links = `${process.env.VUE_APP_COLLAB}/collab/threads/view?target_id=${payload.target_id}&discipline=${payload.dis}&view=${payload.view}`
        //     } else {
        //         links = `${process.env.VUE_APP_COLLAB}/collab/threads/view?target_id=${payload.target_id}&view=${payload.view}`
        //     }
        //     return axios.get(links);
        let links = process.env.VUE_APP_COLLAB + '/collab/threads/view?target_id=' + payload.target_id
            if(payload?.dis) {
                links = links + '&discipline=' + payload.dis
            } 
            if(payload?.state) {
                links = links + '&state=' + payload.state
            }
            if(payload?.thread){
                links = links + '&thread_state=' + payload.thread
            }
            return axios({
                url: links,
                method: 'get'
            })
    },
    getWorkflowId({ dispatch}, name){
        return axios.get(`${process.env.VUE_APP_APPROVAL}/workflows?name=${name}`);
    },
    completeReview({ dispatch}, ts_id) {
        return axios.put(`${process.env.VUE_APP_API_TS}/ts/user/review`, {ts_id:ts_id});
    },
    createRevision({ dispatch}, params){
        return axios.post(`${process.env.VUE_APP_API_TS}/ts`, params);
    },
    getWorkflow({commit}, payload){
        return axios({
                url: process.env.VUE_APP_APPROVAL + '/workflows',
                method: 'get'
            })
    },
    getPRCUserList({ dispatch}, params) {
        return axios.get(`${process.env.VUE_APP_API_TS}/ts/project/user?ts_id=${params.ts_id}&project=${params.project_id}&only_prc=True`);
    },
    publishTS({ dispatch}, params){
        return axios.post(`${process.env.VUE_APP_API_TS}/ts/publish`, params);
    },
    initiateBAFO({ dispatch}, params){
        return axios.put(`${process.env.VUE_APP_API}/bafo/initiate`, params);
    },
}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}